<span *ngIf="!editMode" class="cell"   (dblclick)="onFocus()">
  {{ data }}
  <span
    class="edit-icon"
    (click)="onFocus()"
    nz-icon
    nzType="edit"
    nzTheme="outline"
  ></span>
</span>
<input
  nz-input
  *ngIf="editMode"
  #editfeild
  (focusout)="onFocusOut()"
  [(ngModel)]="data"
  class="cellInput"
  (keydown)="onFocusOut1($event)"
  (blur)="onFocusOut()"
  (focusout)="onFocusOut()"
/>

